import { useEffect, useState } from "react";
import {
  WhatsappLogo, ArrowRight, UsersThree, ChatCircleText, Sparkle,
  ShareNetwork, Lightbulb, FacebookLogo,
  InstagramLogo, TiktokLogo, LinkedinLogo, CheckCircle, YoutubeLogo, XLogo, List, X, Globe,
} from "@phosphor-icons/react";
import CountrySelector from "../../components/web/CountrySelector";
import { BrandCurve, BrandGlow, BrandAccent } from "../../components/web/BrandLines";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const PINK = "#E60059";
const BLUE = "#025582";
const NAVY = "#042E45";
const INK = "#042E45";
const CREAM = "#F8F5F2";
const TEAL = "#025582";
const GRAY = "#4A4A4A";

const openWa = (l) => { if (l) window.open(l, "_blank", "noopener,noreferrer"); };

export default function AspirantesV2() {
  const [data, setData] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    document.title = "Aspirante a Embajador — Héroes Migrantes";
    fetch(`${BACKEND}/api/web/content`).then((r) => r.json()).then(setData).catch(() => setData({}));
  }, []);

  const wa = data?.wa || {}, img = data?.images || {};
  const T = data?.texts || {}, social = data?.social || {};
  const tx = (k, fb) => (T[k] ?? fb);
  const luciana = wa.aspirantes || wa.luciana;

  const formas = [
    { Icon: UsersThree, t: tx("asp.forma_1", "Conectar") },
    { Icon: ChatCircleText, t: tx("asp.forma_2", "Contar") },
    { Icon: Sparkle, t: tx("asp.forma_3", "Crear") },
    { Icon: ShareNetwork, t: tx("asp.forma_4", "Compartir") },
    { Icon: Lightbulb, t: tx("asp.forma_5", "Aportar ideas") },
  ];

  const pasos = [
    { t: tx("asp.paso1_title", "Conocé y usá Héroes Migrantes"), d: tx("asp.paso1_desc", "Explorá · Mirá · Escuchá · Opiná") },
    { t: tx("asp.paso2_title", "Encontrá qué te gusta hacer"), d: tx("asp.paso2_desc", "Conectar · Contar · Compartir · Crear · Aportar ideas") },
    { t: tx("asp.paso3_title", "Probalo"), d: tx("asp.paso3_desc", "Hacé algo real: compartí HM con alguien, contá una historia, aportá una idea o participá en una actividad.") },
  ];

  const galeria = [img.historias, img.eventos, img.asi, img.eco2].filter(Boolean);

  return (
    <div data-testid="aspirantes-v2" style={{ fontFamily: "'Poppins', system-ui, sans-serif", color: INK, background: "#fff" }}>
      {/* HEADER */}
      <header className="sticky top-0 z-50 backdrop-blur" style={{ background: "rgba(255,255,255,.92)", borderBottom: "1px solid #eee" }}>
        <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center" data-testid="asp-logo">
            <img src={data?.logo_url || "/hm-logo.png"} alt="Héroes Migrantes" className="h-6 w-auto object-contain" />
          </a>
          <nav className="hidden md:flex items-center gap-7 text-sm font-semibold">
            <a href="/" className="hover:opacity-70">Inicio</a>
            <a href="/#que-es" className="hover:opacity-70">Qué es Héroes Migrantes</a>
            <a href="/#ecosistema" className="hover:opacity-70">Ecosistema</a>
            <a href="/aspirantes" className="hover:opacity-70">Participá</a>
          </nav>
          <div className="flex items-center gap-2 sm:gap-3">
            <CountrySelector onRequestCountry={() => openWa(luciana)} />
            <button onClick={() => setMenuOpen(true)} data-testid="mobile-menu-open" aria-label="Abrir menú" className="md:hidden w-10 h-10 flex items-center justify-center rounded-full" style={{ color: INK }}>
              <List size={24} weight="bold" />
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE NAV OVERLAY */}
      {menuOpen && (
        <div className="fixed inset-0 z-[90] md:hidden flex flex-col" style={{ background: NAVY }} data-testid="mobile-nav-overlay">
          <div className="flex items-center justify-between px-5 h-16">
            <span className="font-extrabold text-white">Héroes Migrantes</span>
            <button onClick={() => setMenuOpen(false)} data-testid="mobile-menu-close" aria-label="Cerrar menú" className="w-10 h-10 flex items-center justify-center rounded-full text-white"><X size={24} weight="bold" /></button>
          </div>
          <nav className="flex flex-col gap-1 px-5 mt-6 text-2xl font-extrabold text-white">
            {[["/", "Inicio"], ["/#que-es", "Qué es"], ["/#ecosistema", "Ecosistema"], ["/aspirantes", "Participá"]].map(([href, label]) => (
              <a key={label} href={href} onClick={() => setMenuOpen(false)} className="py-3 border-b" style={{ borderColor: "rgba(255,255,255,.12)" }}>{label}</a>
            ))}
          </nav>
          <div className="px-5 mt-8">
            <button onClick={() => { setMenuOpen(false); openWa(luciana); }} className="w-full inline-flex items-center justify-center gap-2 rounded-full px-5 py-3.5 text-base font-bold text-white" style={{ background: BLUE }}>
              <WhatsappLogo size={18} weight="fill" /> Hablar con Luciana
            </button>
          </div>
          <div className="mt-auto px-5 pb-10 flex items-center gap-4" style={{ color: "rgba(255,255,255,.85)" }}>
            {[["facebook", FacebookLogo], ["instagram", InstagramLogo], ["tiktok", TiktokLogo], ["linkedin", LinkedinLogo], ["youtube", YoutubeLogo], ["x", XLogo]].filter(([k]) => social?.[k]).map(([k, Icon]) => (
              <a key={k} href={social[k]} target="_blank" rel="noopener noreferrer"><Icon size={22} weight="fill" /></a>
            ))}
          </div>
        </div>
      )}

      {/* HERO */}
      <section id="top" className="relative overflow-hidden" style={{ background: `linear-gradient(180deg, ${CREAM} 0%, #e9eef3 100%)` }}>
        <div className="max-w-3xl mx-auto px-5 pt-16 pb-20 md:pt-24 md:pb-28 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-[56px] font-extrabold leading-[1.05] mb-6" style={{ color: INK }}>
            {(() => {
              const t = tx("asp.hero_title", "¿Querés involucrarte más en Héroes Migrantes?");
              const parts = t.split("Héroes Migrantes");
              return parts.length > 1 ? <>{parts[0]}<span style={{ color: PINK }}>Héroes Migrantes</span>{parts.slice(1).join("Héroes Migrantes")}</> : t;
            })()}
          </h1>
          <p className="text-base md:text-lg mb-9 max-w-2xl mx-auto" style={{ color: GRAY }}>
            {tx("asp.hero_desc", "Descubrí tu camino para ser parte. Empezás como Aspirante: conocés HM, participás y descubrís cómo podés aportar desde lo que te gusta y sabés hacer. Algunas personas llegan a ser Embajadores.")}
          </p>
          <button onClick={() => openWa(luciana)} data-testid="asp-hero-cta" className="inline-flex items-center gap-2 rounded-full px-6 py-3.5 text-base font-bold text-white transition-transform hover:-translate-y-0.5" style={{ background: BLUE }}>
            <WhatsappLogo size={18} weight="fill" /> {tx("asp.hero_cta", "Hablar con Luciana")}
          </button>
        </div>
      </section>
      <BrandCurve variant="toNavy" bg="#e9eef3" />

      {/* VOS TAMBIÉN PODÉS SER PARTE */}
      <section className="relative overflow-hidden py-16 md:py-20" style={{ background: NAVY }}>
        <BrandGlow className="-right-24 -top-10 w-[520px] md:w-[760px] opacity-[.18]" />
        <div className="relative max-w-7xl mx-auto px-5">
          <div className="grid md:grid-cols-2 gap-6 md:gap-10 items-end mb-10">
            <h2 className="text-3xl md:text-[42px] font-extrabold leading-tight text-white">{tx("asp.vos_title", "Vos también podés ser parte")}</h2>
            <p className="text-base md:text-lg" style={{ color: "rgba(255,255,255,.82)" }}>
              {tx("asp.vos_desc", "Podés compartir algo útil, contar una historia, aportar una idea, participar en una actividad, crear contenido o conectar personas. No todos participan igual. Queremos descubrir qué te nace hacer a vos.")}
            </p>
          </div>
          <div className="relative overflow-hidden mt-12" data-testid="asp-marquee">
            <style>{`@keyframes aspMarquee{from{transform:translateX(0)}to{transform:translateX(-33.333%)}}`}</style>
            <div className="flex gap-8 whitespace-nowrap w-max" style={{ animation: "aspMarquee 24s linear infinite" }}>
              {[...formas, ...formas, ...formas].map((f, i) => (
                <span key={i} className="inline-flex items-center gap-8 text-3xl md:text-5xl font-extrabold" style={{ color: "rgba(255,255,255,.92)" }}>
                  {f.t} <span style={{ color: PINK }}>•</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>
      <BrandCurve variant="fromNavy" bg="#fff" />

      {/* EMPEZÁS COMO ASPIRANTE */}
      <section className="py-16 md:py-20" style={{ background: "#fff" }}>
        <div className="max-w-7xl mx-auto px-5">
          <h2 className="text-3xl md:text-[42px] font-extrabold leading-tight mb-10" style={{ color: INK }}>{tx("asp.empezas_title", "Empezás como Aspirante")}</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="rounded-2xl p-8" style={{ background: CREAM }}>
              <h3 className="text-xl font-extrabold mb-3" style={{ color: INK }}>{tx("asp.quees_title", "¿Qué es ser un Aspirante?")}</h3>
              <p className="text-base mb-3" style={{ color: GRAY }}>{tx("asp.quees_p1", "Es una forma de conocer HM, probar distintas maneras de aportar y que nos vayamos conociendo en la práctica.")}</p>
              <p className="text-base" style={{ color: GRAY }}>{tx("asp.quees_p2", "Ser Aspirante no significa que ya seas Embajador ni que tengas que serlo. No es un examen. Es un descubrimiento mutuo.")}</p>
            </div>
            <div className="rounded-2xl p-8" style={{ background: CREAM }}>
              <h3 className="text-xl font-extrabold mb-3" style={{ color: INK }}>{tx("asp.costo_title", "¿Cuál es el costo?")}</h3>
              <p className="text-base" style={{ color: GRAY }}>{tx("asp.costo_p1", "No es un empleo tradicional ni voluntariado. Empezar como Aspirante no tiene costo.")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* DESCUBRÍ TU FORMA DE PARTICIPAR */}
      <section className="py-16 md:py-24" style={{ background: CREAM }}>
        <div className="max-w-7xl mx-auto px-5 grid md:grid-cols-2 gap-12 md:gap-16">
          <div>
            <h2 className="text-3xl md:text-[46px] font-extrabold leading-[1.05] mb-6" style={{ color: INK }}>{tx("asp.descubri_title", "Descubrí tu forma de participar")}</h2>
            <p className="text-base md:text-lg mb-8" style={{ color: GRAY }}>{tx("asp.descubri_desc", "No son pasos rígidos. Cada Aspirante puede vivirlos de manera diferente.")}</p>
            <BrandAccent />
          </div>
          <div>
            {pasos.map((p, i) => (
              <div key={p.t} data-testid={`paso-${i + 1}`} className="py-7" style={{ borderBottom: i < pasos.length - 1 ? "1px solid #d9d3cc" : "none" }}>
                <h3 className="text-2xl md:text-3xl font-extrabold mb-3" style={{ color: INK }}>{p.t}</h3>
                <p className="text-base md:text-lg" style={{ color: GRAY }}>{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <BrandCurve variant="pinkStripe" bg={CREAM} to="#fff" />

      {/* DE ASPIRANTE A EMBAJADOR */}
      <section className="py-16 md:py-24" style={{ background: "#fff" }}>
        <div className="max-w-7xl mx-auto px-5 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          {galeria.length > 0 && (
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-3xl overflow-hidden h-52 md:h-60"><img src={galeria[0]} alt="" loading="lazy" className="w-full h-full object-cover" /></div>
                <div className="rounded-3xl overflow-hidden h-60 md:h-72"><img src={galeria[2]} alt="" loading="lazy" className="w-full h-full object-cover" /></div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="rounded-3xl overflow-hidden h-60 md:h-72"><img src={galeria[1]} alt="" loading="lazy" className="w-full h-full object-cover" /></div>
                <div className="rounded-3xl overflow-hidden h-52 md:h-60"><img src={galeria[3]} alt="" loading="lazy" className="w-full h-full object-cover" /></div>
              </div>
            </div>
          )}
          <div>
            <h2 className="text-4xl md:text-[52px] font-extrabold leading-[1.02] mb-6">
              <span style={{ color: INK }}>{tx("asp.emb_title_a", "De Aspirante a ")}</span><span style={{ color: PINK }}>{tx("asp.emb_title_b", "Embajador")}</span>
            </h2>
            <p className="text-base md:text-lg mb-4" style={{ color: GRAY }}>
              {tx("asp.emb_p1", "Algunas personas, por su recorrido, participación y lo que realmente aportaron, podrán ser consideradas por HM para convertirse en Embajadores Héroes Migrantes.")}
            </p>
            <p className="text-base md:text-lg mb-4" style={{ color: GRAY }}>
              {tx("asp.emb_p2", "Un Embajador puede aportar de distintas maneras, pero siempre debe demostrar una capacidad real de conectar personas con Héroes Migrantes.")}
            </p>
            <p className="text-base md:text-lg font-bold" style={{ color: INK }}>
              {tx("asp.emb_p3", "La decisión siempre la toma Héroes Migrantes. Nunca es automática.")}
            </p>
          </div>
        </div>
      </section>

      {/* CÓMO SE COMPENSA A UN EMBAJADOR */}
      <section className="py-16 md:py-20" style={{ background: CREAM }}>
        <div className="max-w-4xl mx-auto px-5">
          <h2 className="text-3xl md:text-[42px] font-extrabold leading-tight mb-6" style={{ color: INK }}>{tx("asp.compensa_title", "Cómo se compensa a un Embajador")}</h2>
          <p className="text-base md:text-lg mb-6" style={{ color: GRAY }}>
            {tx("asp.compensa_lead", "Si Héroes Migrantes te aprueba y formaliza como Embajador, y las personas de tu comunidad utilizan servicios de Héroes Migrantes, participás de los ingresos que Héroes Migrantes efectivamente recibe y que son atribuibles a tu red:")}
          </p>
          <div className="mb-10 space-y-1.5">
            <p className="text-base" style={{ color: GRAY }}><b style={{ color: INK }}>{tx("asp.compensa_s1_num", "15%")}</b> {tx("asp.compensa_s1_label", "durante el primer año")}.</p>
            <p className="text-base" style={{ color: GRAY }}><b style={{ color: INK }}>{tx("asp.compensa_s2_num", "8%")}</b> {tx("asp.compensa_s2_label", "a partir del segundo año")}.</p>
            {[tx("asp.compensa_d1", "No es un salario ni un ingreso garantizado."), tx("asp.compensa_d2", "No se paga por referido."), tx("asp.compensa_d3", "Como Aspirante no recibís compensación.")].map((t) => (
              <p key={t} className="text-base" style={{ color: GRAY }}>{t}</p>
            ))}
          </div>
          {/* CTA integrado como tarjeta */}
          <div className="rounded-3xl p-8 md:p-10 text-center" style={{ background: PINK }} data-testid="asp-final-card">
            <h3 className="text-2xl md:text-3xl font-extrabold leading-tight mb-4 text-white">{tx("asp.final_title", "¿Querés descubrir si este camino es para vos?")}</h3>
            <p className="text-base md:text-lg mb-7 max-w-2xl mx-auto" style={{ color: "rgba(255,255,255,.92)" }}>
              {tx("asp.final_desc", "No tenés que decidir hoy si querés ser Embajador. Podés empezar conociendo HM, participando y descubriendo si este camino se parece a vos.")}
            </p>
            <button onClick={() => openWa(luciana)} data-testid="asp-final-cta" className="inline-flex items-center gap-2 rounded-xl px-8 py-4 text-base font-extrabold" style={{ background: "#fff", color: PINK }}>
              <WhatsappLogo size={18} weight="fill" /> {tx("asp.final_cta", "Hablar con Luciana")}
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ background: INK }} className="text-white">
        <div className="max-w-7xl mx-auto px-5 py-12">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 text-center md:text-left">
            <div className="flex flex-col items-center md:items-start">
              <img src="/hm-logo-white.png" alt="Héroes Migrantes" className="h-10 w-auto object-contain mb-3" />
              <span className="font-semibold">Héroes Migrantes</span>
              <p className="text-sm mt-1" style={{ color: "rgba(255,255,255,.6)" }}>{tx("home.footer_tagline", "Tus dos mundos, más cerca.")}</p>
            </div>
            <div className="flex justify-center md:justify-end items-start" style={{ color: "rgba(255,255,255,.85)" }}>
              {(() => {
                const items = [["facebook", FacebookLogo], ["instagram", InstagramLogo], ["tiktok", TiktokLogo], ["linkedin", LinkedinLogo], ["youtube", YoutubeLogo], ["x", XLogo]].filter(([k]) => social?.[k]);
                if (!items.length) return null;
                return <div className="flex items-center gap-4">{items.map(([k, Icon]) => <a key={k} href={social[k]} target="_blank" rel="noopener noreferrer" data-testid={`social-${k}`} className="hover:opacity-70"><Icon size={20} weight="fill" /></a>)}</div>;
              })()}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-6 mt-8 text-center" style={{ borderTop: "1px solid rgba(255,255,255,.12)", color: "rgba(255,255,255,.55)" }}>
            <span className="text-xs">© 2026 Héroes Migrantes</span>
            <span className="text-xs">Privacidad · Términos y condiciones · <a href="/admin" className="hover:underline">Acceso equipo</a></span>
          </div>
        </div>
      </footer>
    </div>
  );
}
